<template>
  <div
    class="book-click-guide"
    :class="{ 'book-click-guide--mobile': !props.isPC }"
    role="dialog"
    aria-modal="true"
    aria-label="开始阅读"
    @pointerdown.stop
    @pointerup.stop
    @click.stop
  >
    <button
      type="button"
      class="book-click-guide__action"
      aria-label="点击任意位置开始阅读。首次进入需要您点击一下，才能播放声音。"
      @click.stop="$emit('confirm')"
    >
      <img
        class="book-click-guide__gesture"
        :src="clickGuideIcon"
        alt=""
        aria-hidden="true"
        draggable="false"
      />
    </button>
  </div>
</template>

<script setup lang="ts">
  import clickGuideIcon from '@/assets/images/book-click.png';

  const props = defineProps<{
    isPC: boolean;
  }>();

  defineEmits<{
    confirm: [];
  }>();
</script>

<style scoped>
  .book-click-guide {
    position: fixed;
    inset: 0;
    z-index: 1100;
  }

  .book-click-guide__action {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    padding: 0;
    overflow: hidden;
    background: rgba(0, 0, 0, 0.15);
    border: 0;
    cursor: pointer;
    touch-action: manipulation;
  }

  .book-click-guide__action:focus-visible {
    outline: 2px solid #eed995;
    outline-offset: -4px;
  }

  .book-click-guide__gesture {
    height: 210px;
    width: auto;
    display: block;
    object-fit: contain;
    pointer-events: none;
  }

  .book-click-guide--mobile .book-click-guide__action {
    background: rgba(0, 0, 0, 0.2);
  }
</style>
